import { Component, OnInit, Input, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import * as moment from "moment";
import {
  CandidatesService,
  SessionService,
  JobOffersService,
  TalentPoolListEntity,
  TalentPoolUser,
} from "../../services";
import { Observable } from "rxjs";
import { WebinarsService } from "app/services/webinars.service";
import {
  CandidateEntityModel,
  CandidateModel,
  JobOfferModel,
  ListEntityModel,
  UserJobsEntityModel,
} from "app/interfaces";
import { environment } from "environments/environment";
import { ToasterService } from "angular2-toaster";

@Component({
  selector: "app-talent-pool-export-btn",
  templateUrl: "./talent-pool-export-btn.component.html",
  styleUrls: ["./talent-pool-export-btn.component.scss"],
  providers: [
    SessionService,
    // CandidatesService,
    // JobOffersService
  ],
})
export class TalentPoolExportBtnComponent implements OnInit {
  public separator = ";";
  public exporting = false;
  public fileName = "";
  @Input() disabled = false;
  @Input() external = false;
  @Input() filters!: any;
  modalRef: BsModalRef;
  template: TemplateRef<any>;

  private status: any = {
    student: "In progress",
    graduated: "Finished",
  };

  constructor(
    private modalService: BsModalService,
    private candidatesService: CandidatesService,
    private ts: ToasterService
  ) { }

  ngOnInit() {
    // console.log(this.candidates);
  }

  get isFilterFull() {
    const variable = JSON.parse(JSON.stringify(this.filters));
    if (typeof variable !== 'object' || variable === null || Array.isArray(variable)) {
      return false;
    }
  
    if (Object.keys(variable).length === 0) {
      return false;
    }
  
    return true;
  }

  private convertCandidatesToCsv(candidates): string {
    // console.log('candidates', candidates);
    // console.log('type', this.type);
    // console.log('referenceId', this.referenceId);
    let csv =
      "Candidate" +
      this.separator +
      "Birthdate" +
      this.separator +
      "Age" +
      this.separator +
      "City" +
      this.separator +
      "University" +
      this.separator +
      "Faculty" +
      this.separator +
      "Course" +
      this.separator +
      "Status" +
      this.separator +
      "Started at" +
      this.separator +
      "Finished at" +
      this.separator +
      "Expected finished at" +
      this.separator +
      "Qualification" +
      this.separator +
      "Vote" +
      this.separator +
      "Average" +
      this.separator +
      "Email" +
      this.separator +
      "Phone" +
      this.separator +
      "Address" +
      this.separator +
      "PDF Link" +
      this.separator +
      "Job Offer Id" +
      this.separator +
      "Job Offer Position" +
      this.separator +
      "Application Date" +
      this.separator +
      "Score" +
      this.separator +
      "Comment" +
      this.separator +
      "Process Status" +
      this.separator +
      "Tags";

    csv += "\n";

    this.fileName = "candidates";
    candidates.forEach((candidate: CandidateModel) => {
      candidate.User.UserJobs.forEach((job: UserJobsEntityModel) => {
        csv += candidate.User.name + " " + candidate.User.surname;
        csv += this.separator;

        csv += candidate.User.birthdate
          ? moment(candidate.User.birthdate).format("DD/MM/YYYY")
          : "";
        csv += this.separator;

        csv += candidate.User.birthdate
          ? moment().diff(candidate.User.birthdate, "years")
          : "";
        csv += this.separator;

        const edu =
          candidate.User.AcademicQualifications.filter(
            (aq) => aq.is_current
          )[0] || null;

        csv += edu && edu.City ? edu.City.name : "";
        csv += this.separator;

        csv += edu && edu.university_name ? edu.university_name : "";
        csv += this.separator;

        csv +=
          edu && edu.StudyTag.MacroStudyTag
            ? edu.StudyTag.MacroStudyTag.name_en.replace(
              /[^a-zA-Z0-9]/g,
              " "
            )
            : "";
        csv += this.separator;

        csv +=
          edu && edu.course_name
            ? edu.course_name.replace(/[^a-zA-Z0-9]/g, " ")
            : "";
        csv += this.separator;

        csv += edu && edu.status ? edu.status : "";
        csv += this.separator;

        csv +=
          edu && edu.started_at
            ? moment(edu.started_at).format("DD/MM/YYYY")
            : "";
        csv += this.separator;

        csv +=
          edu && edu.finished_at
            ? moment(edu.finished_at).format("DD/MM/YYYY")
            : "";
        csv += this.separator;

        csv +=
          edu && edu.expected_finished_at
            ? moment(edu.expected_finished_at).format("DD/MM/YYYY")
            : "";
        csv += this.separator;

        csv +=
          edu && edu.qualification_name
            ? edu.qualification_name.replace(/[^a-zA-Z0-9]/g, " ")
            : "";
        csv += this.separator;

        csv += edu && edu.vote ? edu.vote : "";
        csv += this.separator;

        csv += edu && edu.avg ? edu.avg : "";
        csv += this.separator;

        csv += candidate.User.contact_email || "";
        csv += this.separator;

        csv += candidate.User.contact_phone || "";
        csv += this.separator;

        csv += candidate.User.geolocation
          ? candidate.User.geolocation.formattedName.replace(
            /[^a-zA-Z0-9]/g,
            " "
          )
          : "";
        csv += this.separator;

        csv += `${environment.baseUrl}/pdf-download/${candidate.User.id}/${candidate.User.name}-${candidate.User.surname}`;
        csv += this.separator;

        // job data
        csv += job.JobOffer.id;
        csv += this.separator;

        csv += job.JobOffer.position.replace(/[^a-zA-Z0-9]/g, " ");
        csv += this.separator;

        csv += job.applied_at;
        csv += this.separator;

        csv += Math.round((job as any).user_score) * 100 + "%";
        csv += this.separator;

        csv += job.comment
          ? job.comment.replace(/[^a-zA-Z0-9]/g, " ")
          : " ";
        csv += this.separator;

        csv += job.process_status ? job.process_status : " ";
        csv += this.separator;

        csv += job.Tags
          ? job.Tags.map((a) => a.name)
            .toString()
            .replace(/[^a-zA-Z0-9]/g, " ")
            .trim()
          : "";

        csv += "\n";
      });
    });

    return csv;
  }

  formatApplicationsToCSV(applications: TalentPoolListEntity[]) {
    const headers = [
      /* 'Application ID',
      'User ID', */
      'Name',
      'Surname',
      'Email',
      'Phone',
      'Institute',
      'Study Tag',
      /* 'Study Level', */
      'Job Offer ID',
      'Position',
      'Applied At',
      'Tags'
      /* 'User Score',
      'Process Status',
      'Viewed',
      'CV Title',
      'CV Pages' */
    ];
  
    const rows = [];
  
    applications.forEach((app: TalentPoolListEntity) => {
      const user = app.User;
      const education = user.Education;
      const institute = education.Institute;
      const studyTag = education.StudyTag;
      const cv = app.Curriculum;
      const others = app.other_applications;
  
      others.forEach((otherApp, index) => {
        const isFirst = index === 0;
  
        rows.push([
         /*  isFirst ? app.id : '',
          isFirst ? user.id : '', */
          isFirst ? user.name : '',
          isFirst ? user.surname : '',
          isFirst ? user.contact_email : '',
          isFirst ? user.phone : '',
          isFirst ? institute.name : '',
          isFirst ? studyTag.name_en : '',
          /* isFirst ? education.study_tags_level : '', */
          otherApp.jobOfferId || '',
          otherApp.position || '',
          otherApp.appliedAt || '',
          otherApp.tags.join(', ')
         /*  isFirst ? app.user_score : '',
          isFirst ? app.process_status : '',
          isFirst ? app.viewed : '',
          isFirst ? cv.title : '',
          isFirst ? cv.pages : '' */
        ]);
      });
    });
  
    const csvContent = [
      headers.join(this.separator), // header
      ...rows.map(row =>
        row.map(value =>
          typeof value === 'string' && value.includes(',') ? `"${value}"` : value
        ).join(this.separator)
      )
    ].join('\n');
  
    return csvContent;
  }

  public async printCSV() {
    this.exporting = true;
    const data = await this.getCandidates();
    return;
    const csv = this.formatApplicationsToCSV(data);
    if (csv == null) {
      return;
    }
    console.log('csv', csv);
    
    return this.finalizeCSV(csv);
  }


  async getCandidates(): Promise<any> {
    let page = 0;
    this.exporting = true; this.disabled = true;
    const limit = 50;
    let output = [];

    let sanitizedFilters = JSON.parse(JSON.stringify(this.filters));
    if (sanitizedFilters["job_offers_id"]) {
      sanitizedFilters["job_offers_id"] =
        sanitizedFilters["job_offers_id"].value;
    }
    if (sanitizedFilters["languages_id"]) {
      sanitizedFilters["languages_id"] = Number(
        sanitizedFilters["languages_id"].value
      );
    }
    if (sanitizedFilters["language_level"]) {
      sanitizedFilters["language_level"] = Number(
        sanitizedFilters["language_level"].value
      );
    }
    if (sanitizedFilters["cities_ids"] && sanitizedFilters["cities_ids"][0]) {
      sanitizedFilters["cities_ids"][0] = sanitizedFilters["cities_ids"][0].id;
    }
    if (
      sanitizedFilters["institutes_ids"] &&
      sanitizedFilters["institutes_ids"][0]
    ) {
      sanitizedFilters["institutes_ids"][0] =
        sanitizedFilters["institutes_ids"][0].id;
    }
    if (
      sanitizedFilters["faculty_tags"] &&
      sanitizedFilters["faculty_tags"][0]
    ) {
      sanitizedFilters["faculty_tags"][0] =
        sanitizedFilters["faculty_tags"][0].id;
    }
    if (sanitizedFilters["tags_ids"] && sanitizedFilters["tags_ids"][0]) {
      // sanitizedFilters["tags_ids"][0] = sanitizedFilters["tags_ids"][0].id;
      sanitizedFilters["tags"] = [sanitizedFilters["tags_ids"][0].name];
      delete sanitizedFilters["tags_ids"];
    } else {
      delete sanitizedFilters["tags_ids"];
    }
    if (sanitizedFilters["skills_ids"] && sanitizedFilters["skills_ids"][0]) {
      sanitizedFilters["skills_ids"][0] = sanitizedFilters["skills_ids"][0].id;
    }

    if (sanitizedFilters["study_tags_ids"] && sanitizedFilters["study_tags_ids"][0]) {
      sanitizedFilters["study_tags_ids"][0] = sanitizedFilters["study_tags_ids"][0].id;
    }

    if (sanitizedFilters["geolocations_ids"] && sanitizedFilters["geolocations_ids"][0]) {
      sanitizedFilters["geolocations_ids"][0] = String(sanitizedFilters["geolocations_ids"][0].id);
    }

    if (sanitizedFilters['user_status'] && sanitizedFilters['user_status'] !== 'all') {
      sanitizedFilters['user_status'] = [sanitizedFilters['user_status']]
    } else {
      delete sanitizedFilters['user_status'];
    }

    delete sanitizedFilters['status'];

    const blob = await this.candidatesService.exportTool(sanitizedFilters);

    const a = document.createElement('a');
    const objectUrl = URL.createObjectURL(blob);
    a.href = objectUrl;
    a.download = 'data.csv';
    a.click();
    URL.revokeObjectURL(objectUrl);

      return new Promise((resolve, reject) => {
        this.exporting = false;
        this.disabled = false;
        // this.modalRef.hide();
        resolve(output);
      });

      /*
    return new Promise((resolve, reject) => {
      // try {
        const call = async () => {
          // this.jobOfferService.getCurricula(Number(this.referenceId), page, limit)
          try {
          const data = await this.candidatesService.getTalentPool(sanitizedFilters, page, limit).toPromise();
          output = output.concat(data.list);
          // if (data['count'] < limit) {
          // if (output.length < data.total) {
          // const end =  Math.ceil(data.total/limit) - 1;
          if (data.list.length > 0 && output.length < data.total) {
            page++;
            await new Promise((resolve, reject) => {
              console.log('start wait', new Date().getTime());
              setTimeout(() => {
                console.log('end wait', new Date().getTime());
                resolve(true);
              }, 1000);
            });
            call();
          } else {
            setTimeout(() => {
            resolve(output);
            }, 1000);
          }
        } catch(e) {
          reject();
          console.error(e);
          this.exporting = false;
          this.modalRef.hide();
          this.ts.pop('error', 'An error occured, please try later.')
        }
        };
        call();
    });
    */
  }

  private finalizeCSV(csv) {
    let link;
    link = document.createElement("a");
    const formBlob = new Blob([csv], { type: "text/csv" });
    link.href = window.URL.createObjectURL(formBlob);
    link.setAttribute(
      "download",
      moment().format("DD-MM-YYYY") + "_" + "candidates.csv"
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.exporting = false;
    this.modalRef.hide();
  }

  openModal(template: TemplateRef<any>) {
    this.template = template;
    this.modalRef = this.modalService.show(template);
  }

  changeSeparator(event) {
    this.separator = event.target.value;
  }
}
